import { ReactNode } from 'react'

import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

import { HeroCtaContainer } from './HeroCtaContainer'
import { HeroTitle, HeroTitleTypography } from './HeroTitleTypography'
import {
  HeroRebrandLayout,
  HeroRebrandLayoutProps
} from './layouts/HeroRebrandLayout'

type StandardHeroRebrandProps = {
  title: HeroTitle
  eyebrow?: string
  intro?: string
  ctas?: ReactNode
  imageUrl: string
  unified?: boolean
  mode?: HeroRebrandLayoutProps['mode']
  darkHeader?: boolean
  imageOverlay?: boolean
}

const StandardHeroRebrand = ({
  title,
  ctas,
  eyebrow,
  imageUrl,
  intro,
  unified,
  mode,
  darkHeader,
  imageOverlay
}: StandardHeroRebrandProps) => {
  return (
    <HeroRebrandLayout
      mode={mode}
      layout='image'
      imageUrl={imageUrl}
      unified={unified}
      darkHeader={darkHeader}
      imageOverlay={imageOverlay}
    >
      <div className='hero-text-content text-inherit text-center flex-1 flex flex-col justify-center items-center'>
        {eyebrow ? (
          <TypographyRebrand variant='eyebrow'>{eyebrow}</TypographyRebrand>
        ) : null}
        <HeroTitleTypography title={title} variant='h1' />
        {intro ? (
          <TypographyRebrand variant='introduction'>{intro}</TypographyRebrand>
        ) : null}
        {ctas ? <HeroCtaContainer>{ctas}</HeroCtaContainer> : null}
      </div>
    </HeroRebrandLayout>
  )
}

export default StandardHeroRebrand
